import { IFinancialProfileState } from "@/core/interfaces/financialProfileState.interface";

const financialProfileState: IFinancialProfileState = {
  isFetchingFinancialProfiles: false,
  isFetchingFinancialProfile: false,
  isUnlinkingFinancialProfile: false,
  financialProfile: null,
  financialProfiles: [],
  isLinkingFinancialProfile: false,
};

export default financialProfileState;
